import { gql } from '@apollo/client';

export default gql`
  fragment PaymentReversalInfo on PaymentReversal {
    id
    amount
    amountBeforeTax
    correlationId
    gateway
    idempotencyKey
    kind
    orderId
    orderTransactionId
    processedAt
    providerReversalId
    providerTransactionId
    reason
    requestedAt
    responseCode
    responseMessage
    shippingAmount
    state
    taxAmount
    paymentReversalLines {
      id
      amountBeforeTax
      commercialCategory
      description
      orderItemId
      productId
      providerLineIdentifier
      shippingAmount
      taxAmount
      taxQuoteLineId
      taxjarProductTaxCode
    }
  }
`;
